import React from "react";
import reducer from "store/reducer.js";
import initialState from "store/initialState.js";

export const Store = React.createContext();

export default props => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const value = { state, dispatch };

  return <Store.Provider value={value}>{props.children}</Store.Provider>;
};
